import { useSelector } from 'react-redux'
import type { List, Map } from 'immutable'
import { getPrimary as getPrimaryLanguage } from '../../languages/index'
import { selectUserLanguage } from '../identity/profile/redux/state-types'

const DEFAULT_LANGUAGE = 'en'

/**
 * Derive the raw language value from either an explicit user Map (legacy)
 * or the targeted Redux selector (preferred).
 */
function resolveRawLanguage (
  user: Map<string, unknown> | undefined,
  reduxLanguage: List<string> | string | undefined,
): List<string> | string | undefined {
  // Legacy path: caller passed the Immutable Map explicitly
  if (user !== undefined) return selectUserLanguage({ user })
  // New path: use the targeted Redux value
  return reduxLanguage
}

/**
 * Primary UI / content language derived from Redux `user.data.language`.
 *
 * Overloads:
 *   usePrimaryAppLanguage()           — reads from Redux (preferred)
 *   usePrimaryAppLanguage(userMap)    — legacy: accepts an Immutable Map
 */
export default function usePrimaryAppLanguage (
  user?: Map<string, unknown>,
): string {
  const reduxLanguage = useSelector(selectUserLanguage)
  const rawLanguage = resolveRawLanguage(user, reduxLanguage)
  return getPrimaryLanguage(rawLanguage) || DEFAULT_LANGUAGE
}
